import React from 'react';

const TopBarContext = React.createContext({
  buttons: null,
});

export default TopBarContext;
